import React from "react";
import client from "../../../shared/api-client";
import toQueryString from "../../../shared/toQueryString";
import LabelFormatter from "./LableFormatter";

export default class UserStatus extends React.Component {
  state = {
    status: "",
    user: this.props.user,
  };

  getStatus = () => {
    let params = toQueryString({
      uid: this.props.user.customerId,
    });

    client(`user_profile.php?${params}`).then(
      (response) => {
        this.setState(response);
      },
      (error) => {
        console.error(error);
      }
    );
  };

  componentDidMount() {
    this.getStatus();
  }

  render() {
    return (
      <React.Fragment>
        <LabelFormatter value={this.state.status} />
      </React.Fragment>
    );
  }
}
